import { render, staticRenderFns } from "./Invioce.vue?vue&type=template&id=01a3611c&scoped=true&"
import script from "./Invioce.vue?vue&type=script&lang=js&"
export * from "./Invioce.vue?vue&type=script&lang=js&"
import style0 from "./Invioce.vue?vue&type=style&index=0&id=01a3611c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3611c",
  null
  
)

export default component.exports